import type { plans as en } from "../en/plans";
import type { Messages } from "../types";

export const plans: Messages<typeof en> = {
  gate: {
    notInPlan: "غير متضمنة في خطتك",
    limitReached: "وصلت إلى حد خطتك",
    upgrade: "ترقية",
    lockedCopilot: "المساعد غير متضمن في خطتك.",
    lockedTitle: "{{feature}} غير متضمنة في خطتك",
    lockedBody: "اطلب من مالك المؤسسة الترقية، أو تواصل مع منصة ملفك.",
  },
  names: { trial: "تجريبية", free: "مجانية", pro: "احترافية", business: "أعمال" },
  status: { trial: "تجريبية", active: "فعّالة", past_due: "دفعة مستحقة" },
  features: {
    copilot: "المساعد",
    voice: "الصوت",
    custom_dashboards: "لوحات مخصصة",
    calendar_intelligence: "ذكاء التقويم",
    crisis_alerts: "تنبيهات الأزمات",
    automation_rules: "قواعد الأتمتة",
    ai_replies: "الردود والمسودات الذكية",
    semantic_search: "البحث بالمعنى",
    commenter_enrichment: "إثراء بيانات المعلّقين",
    bulk_actions: "الإجراءات الجماعية",
    exports: "التصدير",
    approvals: "الموافقات",
    customer_360: "ملف العميل الشامل",
    api_access: "الوصول عبر API",
    channel_instagram: "إنستغرام",
    channel_facebook: "فيسبوك",
    channel_messenger: "ماسنجر",
    channel_whatsapp: "واتساب",
    byok: "استخدام مفتاح ذكاء اصطناعي خاص",
  },
  groups: { ai: "الذكاء الاصطناعي", engagement: "التفاعل", insights: "الرؤى", platform: "المنصة", channels: "القنوات" },
  limits: {
    channel_accounts: "الحسابات المتصلة",
    seats: "مقاعد الفريق",
    ai_budget_usd: "ميزانية الذكاء الاصطناعي",
    ai_tokens: "رموز الذكاء الاصطناعي",
    ai_rpm: "طلبات الذكاء الاصطناعي في الدقيقة",
    ai_tpm: "حد سرعة الذكاء الاصطناعي (في الدقيقة)",
    ai_images: "صور الذكاء الاصطناعي",
    copilot_messages: "رسائل المساعد",
    active_rules: "قواعد الأتمتة الفعّالة",
    automation_runs: "تشغيلات الأتمتة",
    scheduled_posts: "المنشورات المجدولة",
    custom_dashboards: "اللوحات المخصصة",
    backfill_posts: "عمق الاستيراد (منشورات)",
    backfill_days: "عمق الاستيراد (أيام)",
    storage_mb: "التخزين",
    exports: "التصديرات",
    api_rpm: "طلبات API في الدقيقة",
    agent_replies: "ردود الوكلاء الأذكياء",
  },
  periods: { none: "", day: "يومياً", month: "شهرياً" },
  unlimited: "غير محدود",
  comingSoon: "قريباً",
  errors: {
    aiBudget: "نفدت ميزانية الذكاء الاصطناعي لهذا الشهر",
    aiBudgetReset: "تتجدد في {{date}}.",
    aiBudgetAdmin: "نفدت ميزانية الذكاء الاصطناعي لمؤسستك لهذا الشهر. راجع الإعدادات ← الخطة والفوترة، أو تواصل مع منصة ملفك.",
    limit: "{{what}}: تم بلوغ الحد ({{used}} من {{max}})",
    limitReset: "يتجدد في {{date}}.",
    feature: "{{what}} غير متضمنة في خطتك",
  },
  banner: {
    near: "{{what}}: استُخدم {{pct}}% ({{used}} من {{max}})",
    reached: "{{what}}: تم بلوغ الحد ({{used}} من {{max}})",
    dismiss: "إخفاء",
    view: "الخطة والفوترة",
  },
  usage: {
    title: "خطتك",
    subtitle: "ما تتضمنه خطتك ومقدار ما استخدمته. تتجدد الحدود في بداية كل فترة (منتصف الليل بتوقيت غرينتش).",
    plan: "الخطة",
    status: "الحالة",
    trialEnds: "تنتهي الفترة التجريبية في {{date}}",
    trialEnded: "انتهت الفترة التجريبية: أنت الآن على الخطة المجانية",
    included: "الميزات المتضمنة",
    notIncluded: "غير متضمنة",
    usage: "الاستخدام",
    resets: "يتجدد {{date}}",
    used: "{{used}} من {{max}}",
    usedUnlimited: "استُخدم {{used}}",
    setting: "إعداد",
    adminsOnly: "يمكن للمالكين والمسؤولين فقط رؤية الاستخدام والفوترة.",
    summary: "مؤسستك على خطة {{plan}}.",
    askOwner: "اطلب من {{owners}} تغيير الخطة.",
    askOwnerGeneric: "اطلب من مالك مؤسستك تغيير الخطة.",
    technical: "حدود تقنية",
    technicalHint: "حدود سرعة تُبقي الخدمة سريعة للجميع. معظم المؤسسات لا تصل إليها.",
    override: "مخصص",
    expires: "حتى {{date}}",
  },
  billing: {
    title: "الفوترة",
    hint: "الدفع الإلكتروني قريباً. تدير منصة ملفك خطتك حالياً.",
    invoices: "الفواتير",
    noInvoices: "لا توجد فواتير بعد",
    noInvoicesHint: "ستظهر الفواتير هنا عند إطلاق الدفع الإلكتروني.",
    contact: "تواصل معنا لتغيير الخطة",
    contactTitle: "تغيير خطتك",
    contactBody: "أخبرنا بالخطة التي تريدها وسنغيّرها لك، عادةً خلال يوم عمل واحد.",
    email: "راسلنا بالبريد",
    whatsapp: "راسلنا على واتساب",
    linkedin: "راسلنا على لينكدإن",
    message: "مرحباً منصة ملفك، نرغب في تغيير خطة {{org}} (الحالية: {{plan}}).",
    copy: "نسخ الرسالة",
    copied: "تم نسخ الرسالة",
  },
};
